import getSavedItems from "./getSavedItems";
import isPlaceholder from "./itemStateSelectors/isPlaceholder";

const getLoadedSavedItems = state =>
  getSavedItems(state).filter(item => !isPlaceholder(item));

export default getLoadedSavedItems;
